import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export function App() {
  return (
    <div className={'container mx-auto'}>
      <Header />
      <Footer />
    </div>
  )
}
